import AuditWidget from "@/components/AuditWidget";
import { SCORE_LABEL } from "@/lib/serviceHubContracts";

type ServiceHubAuditCardProps = {
  cluster: "AEO" | "IMC" | "ABM";
};

/**
 * A low-friction, reusable audit entry point for commercial hub pages. It uses
 * the established OTP-gated AuditWidget rather than introducing a second form
 * or collecting data outside the existing consent and delivery flow.
 */
export default function ServiceHubAuditCard({ cluster }: ServiceHubAuditCardProps) {
  return (
    <section className="mt-10 rounded-2xl border border-[#FF8C00]/30 bg-[#0F1419] p-5 sm:p-7" aria-labelledby={`service-hub-score-${cluster.toLowerCase()}`}>
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#FF8C00]">Start with a high-level baseline</p>
      <h2 id={`service-hub-score-${cluster.toLowerCase()}`} className="mt-3 font-serif text-2xl text-white">{SCORE_LABEL}</h2>
      <p className="mt-3 max-w-3xl text-sm leading-relaxed text-white/65">
        Use the score to establish a broad, client-safe baseline before deciding whether a deeper scope discussion is useful. It is not a promise of rankings, citations, leads or revenue.
      </p>
      <div className="mt-6 max-w-2xl">
        <AuditWidget compact />
      </div>
    </section>
  );
}
